import api from './axios';

// ── Public (no login required) ────────────────────────────────────────────

export const getAvailableSlots = (date) => api.get('/visit-bookings/slots', { params: { date } });

export const createBooking = (payload) => api.post('/visit-bookings', payload);

// ── Admin (ADMIN/CURATOR only) ────────────────────────────────────────────

export const listAdminBookings = (page = 0, size = 20) =>
  api.get('/admin/visit-bookings', { params: { page, size } });

export const cancelBooking = (id) => api.delete(`/admin/visit-bookings/${id}`);
